import { Component, ElementRef, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { selectServices } from '../../store/selectors/app.selectors';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { ServiceListItem } from '../../services/service.common.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { LabelComponent } from '../../common/label/label.component';
import { ValidationErrorsComponent } from '../../common/validation-errors/validation-errors.component';
import { map } from 'rxjs';
import { dateToPLString } from '../../services/helpers';
import { FilterDataPipe } from '../../pipes/filter-data.pipe';
import { AlertComponent } from '../../common/alert/alert.component';

export interface MpzpRegisterItem {
  line: string;
  number: string;
  resolution_number: string;
  resolution_date: string;
  du: string;
  name: string;
  resolution: string;
  raster: string;
  legend: string;
  app: string;
  tag: string;
}

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    HeaderComponent,
    CommonModule,
    FooterComponent,
    LabelComponent,
    ValidationErrorsComponent,
    FormsModule,
    FilterDataPipe,
    AlertComponent
  ],
  templateUrl: './main-page.component.html'
})
export class MainPageComponent implements OnInit {

  private http: HttpClient = inject(HttpClient);

  public mpzpRegisterData: Signal<Array<MpzpRegisterItem> | undefined> = toSignal(this.http.get<Array<MpzpRegisterItem>>('register_mpzp.json').pipe(
    map(items => items.map(v => ({
      ...v,
      tag: `${v.resolution_number} ${dateToPLString(v.resolution_date)} ${v.name}`
    })))
  ));

  public activeTab: any;

  @ViewChild('servicesTab', { static: true })
  servicesTab: ElementRef | undefined;

  @ViewChild('mapTab', { static: true })
  mapTab: ElementRef | undefined;

  @ViewChild('appTab', { static: true })
  appTab: ElementRef | undefined;

  public services: Signal<ServiceListItem[]> = this.store$.selectSignal(selectServices);

  public form = new FormGroup({
    query: new FormControl('', [Validators.required])
  });

  mpzpSearch: string = '';

  constructor(
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (!environment.production) {
      document.body.classList.add('js-show-gov-menu');
    }
  }

  public onSearch(): void {
    if (this.form.valid) {
      this.router.navigate(['e-uslugi'], { queryParams: { 'query': this.form.value.query } });
    }
  }

  public ngOnInit(): void {
    switch (true) {
      case this.route.snapshot.fragment === 'appTab': {
        this.activeTab = this.appTab?.nativeElement;
        break;
      }
      case this.route.snapshot.fragment === 'mapTab': {
        this.activeTab = this.mapTab?.nativeElement;
        break;
      }
      case this.route.snapshot.fragment === 'servicesTab': {
        this.activeTab = this.servicesTab?.nativeElement;
        break;
      }
      default: {
        this.activeTab = this.servicesTab?.nativeElement;
      }
    }
  }
}
